import { format } from 'date-fns';

export const PERIOD_PRESETS = ['all', '24h', '7d', '30d', 'custom'] as const;
export type PeriodPreset = (typeof PERIOD_PRESETS)[number];

export const DEFAULT_PERIOD_PRESET: PeriodPreset = 'all';
export const DATE_QUERY_FORMAT = 'yyyy-MM-dd HH:mm';

export const toApiDate = (value: Date): string => format(value, DATE_QUERY_FORMAT);

/**
 * 주어진 값이 유효한 `PeriodPreset`인지 확인한다.
 */
export const isPeriodPreset = (value: unknown): value is PeriodPreset =>
  typeof value === 'string' && (PERIOD_PRESETS as readonly string[]).includes(value);

/**
 * 프리셋 값에 대응하는 [from, to] 범위를 반환한다.
 * @description
 * - `all`: 최대 조회 기간이 1년이므로 현재 기준 1년 전 ~ 현재
 * - `24h`: 현재 시각 기준 24시간 전 ~ 현재
 * - `7d`: 현재 시각 기준 7일(=168시간) 전 ~ 현재
 * - `30d`: 현재 시각 기준 30일 전 ~ 현재
 * - `custom`: 자체 관리되므로 null 반환
 */
export const getPresetDateRange = (preset: PeriodPreset): [Date, Date] | null => {
  if (preset === 'custom') return null;

  const now = new Date();
  const from = new Date(now);

  switch (preset) {
    case 'all':
      from.setFullYear(from.getFullYear() - 1);
      break;
    case '24h':
      from.setHours(from.getHours() - 24);
      break;
    case '7d':
      from.setDate(from.getDate() - 7);
      break;
    case '30d':
      from.setDate(from.getDate() - 30);
      break;
  }

  return [from, now];
};
